<template>
  <div>
    <el-button :loading="loading" :disabled="loading" type="warning" @click="open">添加分销达人</el-button>
    <el-dialog
        title="分销达人推广二维码"
        :visible.sync="dialogVisible"
        width="600px">
      <div style="display: flex;flex-direction: column; justify-items: center">
        <div style="display: flex;justify-content: center;margin:30px">
          <img style="width: 200px;height: 200px" :src="link">
        </div>

        <div style="display: flex;justify-content: center;margin:10px;font-weight: bolder">
          ‘{{ appName }}’小程序合作码
        </div>

        <div style="margin-top: 20px;margin-bottom: 20px">
          1、请把上方专属合作二维码发送给达人，达人使用【抖音】扫码，达人同意后即与您绑定合作关系；
          <br>
          2、绑定关系的达人直播/发短视频挂载'{{ appName }}'小程序POI券所产生的订单，平台将与您进行结算扣除达人佣金后的提成。
        </div>


      </div>

    </el-dialog>
  </div>
</template>

<script >
import poi from "@/api/poi";
const PoiModel = new poi();
export default {
  props: ['isSetContact'],
  data() {
    return {
      dialogVisible: false,
      appName: '',
      loading: false,
      link: ''
    };
  },
  methods: {
    async open() {
      if(!this.isSetContact){
        this.$message.warning('请先设置给达人的联系方式')
        return
      }
      this.loading = true;
      const res = await PoiModel.getDistributeQrCode().finally(async () => {
        this.loading = false;
      })
      if(!res.data.success) {
        this.$message.error(res.data.message)
        return
      }
      this.link = res.data.data.link
      this.appName = res.data.data.appName
      this.dialogVisible = true
    }
  }
};
</script>


<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/poiDistribution/components/addDarenPop.vue